export const pricing = {
  'pricing.title': 'Simple and Transparent Pricing',
  'pricing.subtitle': 'Choose the plan that fits your needs.',
  'pricing.popular': 'Popular',
  'pricing.contact': 'Questions? Contact us to learn more about our offerings.',

  // ======================
  // PAY-AS-YOU-GO PLANS (Simulators)
  // ======================

  // Individual
  'pricing.payg.individual.name': 'Individual',
  'pricing.payg.individual.price': '€2.99',
  'pricing.payg.individual.description': 'One-time payment - Valid 1 year',
  'pricing.payg.individual.feature1': '5 uses (chatbot + calculator)',
  'pricing.payg.individual.feature2': 'Calculate MaPrimeRénov\', CEE, Éco-PTZ',
  'pricing.payg.individual.feature3': 'AI assistant to find your grants',
  'pricing.payg.individual.feature4': 'Instant results',
  'pricing.payg.individual.cta': 'Buy Now',

  // Entrepreneur
  'pricing.payg.entrepreneur.name': 'Entrepreneur',
  'pricing.payg.entrepreneur.price': '€9.99',
  'pricing.payg.entrepreneur.description': 'One-time payment - Valid 1 year',
  'pricing.payg.entrepreneur.feature1': '5 uses (chatbot + calculator)',
  'pricing.payg.entrepreneur.feature2': 'Business grant search',
  'pricing.payg.entrepreneur.feature3': 'Personalized AI assistant',
  'pricing.payg.entrepreneur.feature4': 'PDF export of results',
  'pricing.payg.entrepreneur.cta': 'Buy Now',

  // Consultant
  'pricing.payg.consultant.name': 'Consultant',
  'pricing.payg.consultant.price': '€14.99',
  'pricing.payg.consultant.description': 'One-time payment - Valid 1 year',
  'pricing.payg.consultant.feature1': '5 uses (chatbot + calculator)',
  'pricing.payg.consultant.feature2': 'Use for your clients',
  'pricing.payg.consultant.feature3': 'Professional report',
  'pricing.payg.consultant.feature4': 'Priority support',
  'pricing.payg.consultant.cta': 'Buy Now',

  // ======================
  // ⚠️ DEPRECATED - OLD SUBSCRIPTION PLANS ⚠️
  // These are kept for backwards compatibility only.
  // The CORRECT pricing is volume-based (see TarifsPage section below).
  // Real pricing: €29/month for 1-10 clients, €59 for 11-25, etc.
  // ======================

  // Solo Plan - DEPRECATED (replaced by volume-based €29/month for 1-10 clients)
  'pricing.solo.name': 'Solo',
  'pricing.solo.price': '€29/month',
  'pricing.solo.description': 'For individual entrepreneurs',
  'pricing.solo.feature1': 'Up to 10 Business Profiles',
  'pricing.solo.feature2': 'Unlimited grant searches',
  'pricing.solo.feature3': 'Intelligent AI matching',
  'pricing.solo.feature4': 'Database of 50,000+ grants',
  'pricing.solo.feature5': 'Application tracking',
  'pricing.solo.feature6': 'Personalized alerts',
  'pricing.solo.cta': 'Get Started',

  // ⚠️ DEPRECATED - All plans below use OLD pricing.
  // CORRECT pricing from TarifsPage: €29 (1-10), €59 (11-25), €99 (26-50), €179 (51-100), €399 (101-250), etc.

  // Pro 10 Plan - DEPRECATED (now €29/month for 1-10 clients)
  'pricing.pro10.name': '1-10 clients',
  'pricing.pro10.price': '€29/month',
  'pricing.pro10.pricePerClient': '€2.90 per client',
  'pricing.pro10.description': 'Up to 10 client profiles',
  'pricing.pro10.feature1': 'Up to 10 Business Profiles',
  'pricing.pro10.feature2': 'All features included',
  'pricing.pro10.feature3': 'Multi-client management',
  'pricing.pro10.feature4': 'Consultant dashboard',
  'pricing.pro10.feature5': 'Custom reports',
  'pricing.pro10.cta': 'Get Started',

  // Pro 20 Plan - DEPRECATED (now part of 11-25 tier at €59/month)
  'pricing.pro20.name': '11-25 clients',
  'pricing.pro20.price': '€59/month',
  'pricing.pro20.pricePerClient': '€2.36 per client',
  'pricing.pro20.description': 'Up to 25 client profiles',
  'pricing.pro20.feature1': 'Up to 25 Business Profiles',
  'pricing.pro20.feature2': 'All features included',
  'pricing.pro20.feature3': 'Bulk operations',
  'pricing.pro20.feature4': 'Batch exports',
  'pricing.pro20.feature5': 'Priority support',
  'pricing.pro20.cta': 'Get Started',

  // Pro 40 Plan - DEPRECATED (now part of 26-50 tier at €99/month)
  'pricing.pro40.name': '26-50 clients',
  'pricing.pro40.price': '€99/month',
  'pricing.pro40.pricePerClient': '€1.98 per client',
  'pricing.pro40.description': 'Up to 50 client profiles',
  'pricing.pro40.feature1': 'Up to 50 Business Profiles',
  'pricing.pro40.feature2': 'All features included',
  'pricing.pro40.feature3': 'Advanced automations',
  'pricing.pro40.feature4': 'API integration',
  'pricing.pro40.feature5': 'Dedicated account manager',
  'pricing.pro40.cta': 'Get Started',

  // Pro 80 Plan - DEPRECATED (now part of 51-100 tier at €179/month)
  'pricing.pro80.name': '51-100 clients',
  'pricing.pro80.price': '€179/month',
  'pricing.pro80.pricePerClient': '€1.79 per client',
  'pricing.pro80.description': 'Up to 100 client profiles',
  'pricing.pro80.feature1': 'Up to 100 Business Profiles',
  'pricing.pro80.feature2': 'All features included',
  'pricing.pro80.feature3': 'Unlimited team management',
  'pricing.pro80.feature4': 'Custom training',
  'pricing.pro80.feature5': 'Phone support',
  'pricing.pro80.cta': 'Get Started',

  // Pro 150 Plan - DEPRECATED (now part of 101-250 tier at €399/month)
  'pricing.pro150.name': '101-250 clients',
  'pricing.pro150.price': '€399/month',
  'pricing.pro150.pricePerClient': '€1.60 per client',
  'pricing.pro150.description': 'Up to 250 client profiles',
  'pricing.pro150.feature1': 'Up to 250 Business Profiles',
  'pricing.pro150.feature2': 'All features included',
  'pricing.pro150.feature3': 'Unlimited team management',
  'pricing.pro150.feature4': 'Full customization',
  'pricing.pro150.feature5': '99.9% SLA',
  'pricing.pro150.cta': 'Get Started',

  // Pro 300 Plan - DEPRECATED (now part of 251-500 tier at €699/month)
  'pricing.pro300.name': '251-500 clients',
  'pricing.pro300.price': '€699/month',
  'pricing.pro300.pricePerClient': '€1.40 per client',
  'pricing.pro300.description': 'Up to 500 client profiles',
  'pricing.pro300.feature1': 'Up to 500 Business Profiles',
  'pricing.pro300.feature2': 'All features included',
  'pricing.pro300.feature3': 'Dedicated deployment',
  'pricing.pro300.feature4': 'Custom integrations',
  'pricing.pro300.feature5': 'Dedicated project manager',
  'pricing.pro300.cta': 'Contact Us',

  // Pro 500 Plan - DEPRECATED (now part of 501-1000 tier at €1,199/month)
  'pricing.pro500.name': '501-1000 clients',
  'pricing.pro500.price': '€1,199/month',
  'pricing.pro500.pricePerClient': '€1.20 per client',
  'pricing.pro500.description': 'Up to 1000 client profiles',
  'pricing.pro500.feature1': 'Up to 1000 Business Profiles',
  'pricing.pro500.feature2': 'All features included',
  'pricing.pro500.feature3': 'Dedicated infrastructure',
  'pricing.pro500.feature4': 'Custom development',
  'pricing.pro500.feature5': 'Continuous training',
  'pricing.pro500.cta': 'Contact Us',

  // Enterprise 1000+ Plan - DEPRECATED (now 1001-2000 at €2,299/month)
  'pricing.enterprise.name': '1001+ clients',
  'pricing.enterprise.price': '€2,299/month',
  'pricing.enterprise.pricePerClient': '€1.15 per client',
  'pricing.enterprise.description': 'More than 1000 client profiles',
  'pricing.enterprise.feature1': '1000+ Business Profiles',
  'pricing.enterprise.feature2': 'All features included',
  'pricing.enterprise.feature3': 'Dedicated servers',
  'pricing.enterprise.feature4': 'Custom enterprise contract',
  'pricing.enterprise.feature5': '24/7 Support',
  'pricing.enterprise.feature6': 'Custom compliance',
  'pricing.enterprise.cta': 'Contact Us',

  // ======================
  // VOLUME-BASED PRICING PAGE (TarifsPage)
  // ======================

  // SEO
  'pricing.page.seo.title': 'subvention360 Pricing - Volume-based Billing',
  'pricing.page.seo.description': 'Transparent and degressive pricing. Like an electricity bill: pay only for your client imports. From €29/month (10 imports) to €4,499/month (5,000 imports). Every import counts, even re-imports.',
  'pricing.page.seo.keywords': 'subvention360 pricing, subsidy platform prices, volume billing, B2B SaaS pricing, degressive rates, price per import, electricity-style billing',

  // Hero Section
  'pricing.page.hero.heading': 'Pay only for what you consume',
  'pricing.page.hero.description': 'Monthly billing based on <strong>import volume</strong> — like your electricity bill. Automatic debit on the <strong>5th of the following month</strong>.',
  'pricing.page.hero.badge1': 'Degressive pricing',
  'pricing.page.hero.badge2': 'No commitment',
  'pricing.page.hero.badge3': 'Cancel anytime',

  // Single Subscription Section
  'pricing.page.team.title': 'One subscription for your entire team',
  'pricing.page.team.feature1': '<strong>Unlimited users</strong> — Add as many team members as you want, at no extra cost',
  'pricing.page.team.feature2': '<strong>Single billing</strong> — One subscription per organization, based only on imported client volume',
  'pricing.page.team.feature3': '<strong>Full collaboration</strong> — Your entire team accesses the same features, data, and reports',
  'pricing.page.team.important': '<strong>Important:</strong> You only pay for the number of clients imported into your account, never for the number of users or collaborators.',

  // Pricing Grid
  'pricing.page.grid.title': 'Pricing Grid',
  'pricing.page.grid.subtitle': 'Save up to <strong className="text-green-600">69%</strong> per client by increasing your volume',
  'pricing.page.grid.header.clients': 'Active Clients',
  'pricing.page.grid.header.monthlyPrice': 'Monthly Price',
  'pricing.page.grid.header.pricePerClient': 'Unit Cost',
  'pricing.page.grid.header.idealFor': 'Ideal for',

  // Pricing Tiers - Ideal For Labels
  'pricing.page.tier.1-10.idealFor': 'Individual consultants',
  'pricing.page.tier.11-25.idealFor': 'Small consulting teams',
  'pricing.page.tier.26-50.idealFor': 'Growing firms',
  'pricing.page.tier.51-100.idealFor': 'SME consulting',
  'pricing.page.tier.101-250.idealFor': 'Established firms',
  'pricing.page.tier.251-500.idealFor': 'Large firms',
  'pricing.page.tier.501-1000.idealFor': 'Large groups',
  'pricing.page.tier.1001-2000.idealFor': 'Very high volumes',
  'pricing.page.tier.2001-5000.idealFor': 'Enterprise scale',

  // Pricing Cards (Mobile)
  'pricing.page.card.clients': 'clients',
  'pricing.page.card.monthlyPrice': 'Monthly price',
  'pricing.page.card.perClient': 'Per client',

  // Savings Section
  'pricing.page.savings.title': 'Automatic savings with growth',
  'pricing.page.savings.tier1': '10 clients',
  'pricing.page.savings.tier1Price': '€2.90 per client',
  'pricing.page.savings.tier2': '100 clients',
  'pricing.page.savings.tier2Price': '€1.79 per client <span className="text-green-600 font-semibold">(-38%)</span>',
  'pricing.page.savings.tier3': '5,000 clients',
  'pricing.page.savings.tier3Price': '€0.90 per client <span className="text-green-600 font-semibold">(-69%)</span>',

  // CTA
  'pricing.page.cta.button': 'Start now',
  'pricing.page.cta.footer': 'Secure payment • Monthly billing • Cancel anytime',

  // How Billing Works
  'pricing.page.billing.title': 'How does billing work?',
  'pricing.page.billing.subtitle': 'Simple and predictable, based on your actual usage',

  'pricing.page.billing.step1.title': '1. Import your clients',
  'pricing.page.billing.step1.description': 'Upload your client list via Excel, CSV, or API integration',

  'pricing.page.billing.step2.title': '2. We count imports',
  'pricing.page.billing.step2.description': 'Each imported profile is counted (even re-imports of the same client)',

  'pricing.page.billing.step3.title': '3. Automatic monthly debit',
  'pricing.page.billing.step3.description': 'On the 5th of each month, you\'re charged for the previous month\'s imports',

  'pricing.page.billing.example.title': 'Example',
  'pricing.page.billing.example.description': 'You import <strong>75 clients</strong> in October → You\'re charged <strong>€99</strong> on November 5th',

  // What Counts Section
  'pricing.page.counts.title': 'What counts as an import?',
  'pricing.page.counts.item1.title': 'New profile',
  'pricing.page.counts.item1.description': 'Each new client added to your account = 1 import',
  'pricing.page.counts.item2.title': 'Profile update',
  'pricing.page.counts.item2.description': 'Re-importing an existing profile (to update info) = 1 import',
  'pricing.page.counts.item3.title': 'Bulk imports',
  'pricing.page.counts.item3.description': 'If you import 100 profiles at once = 100 imports',
  'pricing.page.counts.note': 'Note: Searches, exports, and data consultations do not count as imports. Only adding/updating client profiles is charged.',

  // Payment Methods
  'pricing.page.payment.title': 'Payment Methods',
  'pricing.page.payment.subtitle': 'Secure and flexible',
  'pricing.page.payment.card.title': 'Credit Card',
  'pricing.page.payment.card.description': 'Visa, Mastercard, American Express accepted',
  'pricing.page.payment.card.badge': 'Instant',
  'pricing.page.payment.sepa.title': 'SEPA Direct Debit',
  'pricing.page.payment.sepa.description': 'Direct debit from your European bank account',
  'pricing.page.payment.sepa.badge': 'Preferred',
  'pricing.page.payment.invoice.title': 'Invoice',
  'pricing.page.payment.invoice.description': 'For volumes >1,000 clients/month',
  'pricing.page.payment.invoice.badge': 'Enterprise',
  'pricing.page.payment.security': 'All payments are secured by Stripe, the market leader in payment security.',

  // FAQ
  'pricing.page.faq.title': 'Frequently Asked Questions',
  'pricing.page.faq.q1': 'Can I change plans during the month?',
  'pricing.page.faq.a1': 'Yes, you can import as many clients as you want. You\'ll be charged the corresponding tier at the end of the month.',
  'pricing.page.faq.q2': 'What happens if I exceed my tier?',
  'pricing.page.faq.a2': 'Nothing! You automatically move to the next tier. The charge adjusts to your actual volume.',
  'pricing.page.faq.q3': 'Can I cancel my subscription?',
  'pricing.page.faq.a3': 'Yes, at any time. Simply stop importing clients. You\'ll only pay for the current month.',
  'pricing.page.faq.q4': 'Are there setup fees?',
  'pricing.page.faq.a4': 'No setup fees, no hidden costs. You only pay for your client imports.',
  'pricing.page.faq.q5': 'Can I get an invoice?',
  'pricing.page.faq.a5': 'Yes, you receive a detailed invoice on the 5th of each month with the breakdown of your imports.',
  'pricing.page.faq.q6': 'Why do you ask for bank details at signup?',
  'pricing.page.faq.a6': 'We request your bank details to: streamline your experience (no later steps required), verify your professional status (service reserved for consulting firms), and maintain competitive pricing. Rest assured: no charge without your explicit consent, we contact you before any deadline, and your account remains accessible even without a subscription.',

  // Final CTA
  'pricing.page.finalCta.title': 'Ready to start?',
  'pricing.page.finalCta.subtitle': 'Create your account in 30 seconds and start identifying grants for your clients',
  'pricing.page.finalCta.button': 'Start now',
  'pricing.page.finalCta.footer': 'No credit card required for trial • Full access • Cancel anytime',
  'pricing.page.finalCta.backHome': 'Back to Home',

  // Navigation (Header)
  'pricing.page.nav.features': 'Features',
  'pricing.page.nav.pricing': 'Pricing',
  'pricing.page.nav.company': 'Company',
  'pricing.page.nav.login': 'Sign In',
  'pricing.page.nav.trial': 'Try Free',
  'pricing.page.nav.dashboard': 'Dashboard',

  // Hero Section - Additional
  'pricing.page.hero.commitment': 'Our commitment:',
  'pricing.page.hero.commitment.description': 'Simple and predictable billing based on your monthly <strong>active clients</strong>.',
  'pricing.page.hero.commitment.bullet1': 'Secure automatic debit on the <strong>5th of the following month</strong>',
  'pricing.page.hero.commitment.bullet2': 'Automatic degressive pricing based on your growth',
  'pricing.page.hero.commitment.bullet3': 'One subscription for your entire team — unlimited collaborators included',

  // Pricing Grid Explanation
  'pricing.page.grid.explanation1': 'We count all your clients, Active and New, in the platform each month.',
  'pricing.page.grid.explanation2': 'Inactive clients and Deletions are applied from the following month, allowing you to quickly adjust your billing volume.',

  // Billing Example Section
  'pricing.page.billing.example.jan5': 'January 5',
  'pricing.page.billing.example.jan5.action': 'Import of 200 clients',
  'pricing.page.billing.example.jan5.volume': 'Volume = 200',
  'pricing.page.billing.example.jan25': 'January 25',
  'pricing.page.billing.example.jan25.action': 'Deletion of 100 clients',
  'pricing.page.billing.example.jan25.volume': 'Volume remains 200',
  'pricing.page.billing.example.feb5': 'February 5',
  'pricing.page.billing.example.feb5.action': 'Tier 121-300 clients',
  'pricing.page.billing.example.feb5.volume': 'Billed €899 excl. VAT',
  'pricing.page.billing.example.summary': '<strong>With 200 Creations and 100 Deletions in January, your counter is at 100 Active clients on February 1st.</strong>',
  'pricing.page.billing.example.note': 'Only clients active during a given month are counted in billing. You don\'t need to delete a client: simply set them to inactive status. You can reactivate them at any time without recreating their file or losing information.',

  // Security Section
  'pricing.page.security.title': 'Your data secure, your peace of mind guaranteed',
  'pricing.page.security.subtitle': 'Our certified infrastructure protects your most sensitive information',

  'pricing.page.security.hosting.title': 'Secure sovereign hosting',
  'pricing.page.security.hosting.item1': 'European servers certified SOC 2 Type 2',
  'pricing.page.security.hosting.item2': 'Infrastructure hosted in the European Union (Frankfurt)',
  'pricing.page.security.hosting.item3': 'Multiple automatic backups',

  'pricing.page.security.protection.title': 'Advanced data protection',
  'pricing.page.security.protection.item1': 'AES-256 algorithms for data at rest',
  'pricing.page.security.protection.item2': 'TLS 1.2+ protocols for secure transfers',
  'pricing.page.security.protection.item3': 'Secure authentication by email and password',

  'pricing.page.security.compliance.title': 'Complete regulatory compliance',
  'pricing.page.security.compliance.item1': 'Full GDPR compliance',
  'pricing.page.security.compliance.item2': 'Respect for CNIL guidelines',
  'pricing.page.security.compliance.item3': 'Regular audit procedures (SOC 2 Type 2)',

  'pricing.page.security.privacy.title': 'Absolute confidentiality',
  'pricing.page.security.privacy.item1': 'No data sharing with third parties',
  'pricing.page.security.privacy.item2': 'No reuse of your information',
  'pricing.page.security.privacy.item3': 'Your clients remain entirely yours',
} as const;
